<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>进度管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container content-container>
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <el-col
              :span="12"
              style="text-align: left;margin: 8px 0;padding-left: 20px;font-size: 16px;align-items: center;height: 30px;padding-top: 10px;"
            >
              <el-row>
                <el-col :span="6">
                  合同开工日期
                  <span style="color: #17B2FE;">{{num.wcl}}</span>
                </el-col>
                <el-col :span="6">
                  合同完成日期
                  <span style="color: #17B2FE;">{{num.ycl}}</span>
                </el-col>
                <el-col :span="6">
                  施工天数
                  <span style="color: #17B2FE;">{{num.ysh}}</span>天
                </el-col>
                <el-col :span="6">
                  竣工倒计时
                  <span style="color: #17B2FE;">{{num.ycs}}</span>天
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :span="12"
              style="text-align: right;margin: 8px 0;display: flex;justify-content: flex-end;align-items: center;"
            >
              <span class="colorSign" style="background: #45ABF0;"></span>
              <span class="signName">计划进度</span>
              <span class="colorSign" style="background: #45DEF0;"></span>
              <span class="signName">提报进度</span>
              <el-button
                class="layui-btn"
                @click="addPlanCtl"
                style="background: #4D7BF4;color:#fff;"
              >新增计划</el-button>
            </el-col>
          </div>
          <!-- 表格 -->
          <div class="table_wrapper">
            <div class="process-l">
              <div
                class="head-l"
                style="display: flex;justify-content: center;align-items: center;align-content: center;padding: 10px;box-sizing: border-box;"
              >
                <!-- <span v-if="today==selectDay" class="head-cell" :class="{cur:today==selectDay}">今</span> -->
                <el-date-picker
                  v-model="time"
                  type="month"
                  value-format = 'yyyy-MM'
                  @change="changYear"
                  placeholder="选择时间"
                ></el-date-picker>
              </div>
              <div class="box-l">
                <div
                  class="process-title"
                  v-for="item in progressList"
                  :key="item.id"
                >{{item.planName}}</div>
              </div>
            </div>
            <div class="process-r">
              <div class="process-box">
                <div class="head-r">
                  <div class="head-r-box">{{curMonth}}</div>
                  <div class="head-r-box">
                    <div
                      class="head-cell"
                      :class="{'cur':selectDay == item.val}"
                      v-for="item in dayList"
                      @click="setCurDay(item.val)"
                      :key="item.val"
                      style="position: relative;"
                    >
                      <span style="border-radius: 6px;">{{item.name}}</span>
                      <span class="head-cell-line" :style="{height:(progressList.length*120+30)+'px'}"></span>
                    </div>
                  </div>
                </div>
                <div class="box-r">
                  <div class="process-box-item" v-for="item in progressList" :key="item.id">
                    <div class="item-div">
                      <div
                        class="item-span color1"
                        :style="{width:item.itemWidth+'px',left:item.itemLeft+'px'}"
                      >
                        <span
                          class="span-txt"
                          :style="{left: item.cellLen+'px'}"
                        >{{item.planProgress}}%</span>
                      </div>
                    </div>
                    <div class="item-div">
                      <div
                        class="item-span color2"
                        v-if="item.subWidth>0"
                        :style="{width:item.subWidth+'px',left:item.itemLeft+'px'}"
                      >
                        <span
                          class="span-txt"
                          v-if="item.subCellLeft >= 0"
                          :style="{left: item.subCellLeft+'px'}"
                        >{{item.submitProgress}}%</span>
                      </div>
                    </div>
                    <img src="../../assets/image/progress_edit.png" class="modPlanBtn" @click="modPlanBtn(item)" />
                    <img src="../../assets/image/progress_manger.png" class="mangerBtn" v-if="item.type!=3" @click="paneCtl(item.id)" />
                    <img src="../../assets/image/progress_sub.png" class="submit-btn" v-if="item.type!=2" @click="submitCtl(item.id)" />
                    <!-- <el-button type="success" class="modPlanBtn" @click="modPlanBtn(item)">计划修改</el-button> -->
                    <!-- <button
                      class="layui-btn paneCtl"
                      v-if="item.type!=3"
                      @click="paneCtl(item.id)"
                    >计划管理</button> -->
                    <!-- <button
                      class="layui-btn submitCtl"
                      v-if="item.type!=2"
                      @click="submitCtl(item.id)"
                    >进度提报</button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-main>
      <!-- 新增窗口 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="addFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="500px"
        class="add-form"
      >
        <el-form :model="addForm" ref="addForm" label-width="100px" :label-position="labelPosition">
          <el-form-item label="选择继承：">
            <el-select
              v-model="addForm.levelId"
              placeholder="请选择"
              @change="changeLevel"
              clearable
              filterable
            >
              <el-option
                v-for="item in optPlans"
                :key="item.id"
                :label="item.planName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划名称：" required>
            <el-input v-model="addForm.planName" autocomplete="off" placeholder="请输入计划名称"></el-input>
          </el-form-item>
          <el-form-item label>
            <el-input type="textarea" v-model="addForm.planDescribe" placeholder="请输入计划描述"></el-input>
          </el-form-item>
          <el-form-item label="起始日期" required>
            <el-col :span="11">
              <el-date-picker
                type="date"
                disabled
                placeholder="选择开始日期"
                v-model="addForm.plannedStartTime"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <!-- <el-col class="line" :span="2" style="text-align: center;">至</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="选择结束日期" v-model="addForm.plannedEndTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-col>-->
          </el-form-item>
          <el-form-item label="计划天数：" required>
            <el-input v-model="addForm.plannedDate" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAddRow">确 定</el-button>
        </div>
      </el-dialog>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      num: {
        wcl: '',
        ycl: '',
        ysh: '',
        ycs: ''
      },
      projectId: '',
      progressList: [], //进度列表
      time: util.myTime.getCurMonth(), //当前选择月份
      // selMonth: '',//当前选择月份
      today: util.myTime.formatTime(new Date(), 'YYYY-MM-dd'), //今天
      selectDay: util.myTime.getCurTime(), //选择的时间
      dayList: [], //日期列表
      curMonth: '', //当前月
      dialogTitle: '新增计划', //弹出框标题
      addFormVisible: false, //弹出框展示标识
      addForm: {
        //添加内容
        id: '',
        planName: '', //计划名称
        planDescribe: '',
        plannedStartTime: '',
        plannedEndTime: '',
        levelId: '', //同级别的id
        plannedDate: '' //计划天数
      },
      labelPosition: 'top',
      optPlans: []
    }
  },
  mounted() {
    // var str = new Date().getFullYear() + ''
    // this.selYear = str
    this.projectId = this.$store.state.groupId
    if (this.projectId == '') {
      store.commit('setGroupId')
      this.projectId = this.$store.state.groupId
    }
    this.addForm.projectId = this.projectId
    this.getData()
    this.selectDay = util.myTime.getCurTime()
    //this.curMonth = util.myTime.formatTime(this.selectDay,'YYYY年');
    this.getDay(this.time)
    // this.getMonth()
  },
  methods: {
    //获取日期
    getDay(month) {
      var curDay = util.myTime.getMonthDay(month)
      //var month = util.myTime.getCurMonth(day)
      var dayList = []
      for (var i = 1; i <= curDay; i++) {
        var name = i
        var day = i < 9 ? '0' + i : i
        var obj = {
          name: name,
          val: month + '-' + day
        }
        dayList.push(obj)
      }
      this.dayList = dayList
    },
    //获取月份
    getMonth(year) {
      var year = year ? year : new Date().getFullYear()
      var dayList = []
      for (var i = 1; i <= 12; i++) {
        var name = i
        var obj = {
          name: name,
          val: year + '-' + i
        }
        dayList.push(obj)
      }
      this.dayList = dayList
    },
    getData() {
      var that = this
      myHttp
        .getProgress({
          projectId: this.projectId
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            that.num.wcl = util.myTime.formatTime(
              resp.data.data.project[0].startDate,
              'YYYY.MM.dd'
            )
            that.num.ycl = util.myTime.formatTime(
              resp.data.data.project[0].endDate,
              'YYYY.MM.dd'
            )
            that.num.ysh = that.getYsh(
              resp.data.data.project[0].startDate,
              resp.data.data.project[0].endDate
            )
            that.num.ycs = that.getYcs(
              resp.data.data.project[0].startDate,
              resp.data.data.project[0].endDate
            )
            that.setProgressList(resp.data.data.progress, that.time)
          }
        })
    },
    //数据扩展
    setProgressList(data, month) {
      var list = data || []
      var head = '',
        box = ''
      var day = util.myTime.getCurTime()
      var start = month + '-01',
        end = month + '-' + util.myTime.getMonthDay(month)
      var objList = []
      for (var i = 0; i < list.length; i++) {
        var plannedStartTime = this.getPlanDay(
          list[i].plannedStartTime,
          start,
          end
        )
        var plannedEndTime = this.getPlanDay(list[i].plannedEndTime, start, end)
        // console.log(list[i].plannedStartTime, list[i].plannedEndTime)
        // console.log(plannedStartTime, plannedEndTime)
        if (
          plannedStartTime == '' ||
          plannedEndTime == '' ||
          plannedStartTime == plannedEndTime
        ) {
          continue
        }

        var itemWidth = util.myTime.getdayByDate(plannedStartTime, plannedEndTime) * 47+47
        var itemLeft = this.getItemLeft(plannedStartTime, start, end)
        var cellLen = this.getLeft(plannedStartTime, plannedEndTime,new Date(this.selectDay).getTime())
        var subWidth = 0
        var subCellLeft = -1
        if(new Date(list[i].actualStartTime).getTime()>=new Date(plannedEndTime).getTime()){
          subWidth = itemWidth
          // subCellLeft = -1
        }else if(new Date(list[i].actualStartTime).getTime()>=new Date(plannedStartTime).getTime()){
          subWidth = util.myTime.getdayByDate(plannedStartTime, list[i].actualStartTime) * 47+47
          subCellLeft = this.getLeft(plannedStartTime, list[i].actualStartTime,list[i].actualStartTime)
        }else{
          subWidth = 0
        }
        // console.log(subWidth,subCellLeft)
        // console.log(itemWidth,itemLeft)
        // console.log(plannedStartTime,plannedEndTime)
        // console.log(list[i])
        var planProgress = this.getPlanProgress(
          list[i].plannedStartTime,
          list[i].plannedEndTime
        )
        var submitProgress = this.getSubmitProgress(list[i].completedProgress)

        list[i].itemWidth = itemWidth
        list[i].itemLeft = itemLeft
        list[i].cellLen = cellLen
        list[i].subWidth = subWidth
        list[i].subCellLeft = subCellLeft
        list[i].planProgress = planProgress
        list[i].submitProgress = submitProgress
        objList.push(list[i])
      }
      this.progressList = objList
      //this.optPlans = list
    },
    getCellLeft(t1,t2){

    },
    /**
     * 获取可继承列表
     */
    getOptPlans(time) {
      var that = this
      myHttp
        .getProgressTime({
          startDate: time,
          projectId: this.projectId,
          progressId: this.addForm.id
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.progress || []
            that.optPlans = list
          }
        })
    },
    //获取竣工倒计时
    getYcs(s1, s2) {
      var result = 0
      if (
        new Date().getTime() >= new Date(s1).getTime() &&
        new Date().getTime() < new Date(s2).getTime()
      ) {
        result = util.myTime.getdayByDate(new Date(), s2)
      } else if (new Date().getTime() < new Date(s1).getTime()) {
        result = util.myTime.getdayByDate(s1, s2)
      }
      return result
    },
    //获取施工天数
    getYsh(s1, s2) {
      var result = 0
      if (
        new Date().getTime() >= new Date(s1).getTime() &&
        new Date().getTime() < new Date(s2).getTime()
      ) {
        result = util.myTime.getdayByDate(s1, new Date()) + 1
      } else if (new Date().getTime() >= new Date(s2).getTime()) {
        result = util.myTime.getdayByDate(s1, s2) + 1
      }
      return result
    },
    /**
     * 获取开始时间
     */
    getPlanDay(day, s1, s2) {
      var result = s1
      if (new Date(day).getTime() < new Date(s1)) {
        result = s1
      } else if (new Date(day).getTime() > new Date(s2)) {
        result = s2
      } else {
        result = day
      }
      return result
    },
    //点击日期
    setCurDay(val) {
      this.selectDay = val
      this.setProgressList(this.progressList,this.time)
    },
    paneCtl(val) {
      this.$router.push({ name: 'dute', params: { id: val } })
    },
    submitCtl(val) {
      this.$router.push({ name: 'duteDetail', params: { id: val } })
    },
    /**
     * 获取计划left
     */
    getItemLeft(time, s1, s2) {
      var result = 0
      if (new Date(time).getTime() <= new Date(s1).getTime()) {
        result = 0
      } else if (
        new Date(time).getTime() > new Date(s1).getTime() &&
        new Date(time).getTime() <= new Date(s2).getTime()
      ) {
        result = util.myTime.getdayByDate(s1, time) * 47
      } else {
        result = util.myTime.getdayByDate(s1, s2) * 47
      }
      return result
    },
    /**
     * 获取进度单元left
     */
    getLeft(s1, s2 , time) {
      var result = 0
      var day = time?util.myTime.getCurTime(new Date(time).getTime()):util.myTime.getCurTime()
      if (new Date(day).getTime() <= new Date(s1).getTime()) {
        result = 1
      } else if (
        new Date(day).getTime() > new Date(s1).getTime() &&
        new Date(day).getTime() <= new Date(s2).getTime()
      ) {
        result = util.myTime.getdayByDate(s1, day) * 47
      } else {
        result = util.myTime.getdayByDate(s1, s2) * 47
      }
      return result
    },
    /**
     * 获取计划进度%
     */
    getPlanProgress(s1, s2) {
      var day = util.myTime.getCurTime(new Date(this.selectDay).getTime())
      var result = ''
      if (
        new Date(day).getTime() >= new Date(s1).getTime() &&
        new Date(day).getTime() <= new Date(s2).getTime()
      ) {
        result = (
          (util.myTime.getdayByDate(s1, day) /
            util.myTime.getdayByDate(s1, s2)) *
          100
        ).toFixed(2)
      } else if (new Date(day).getTime() >= new Date(s2).getTime()) {
        result = 100
      } else if (new Date(day).getTime() < new Date(s1).getTime()) {
        result = 0
      }
      return result
    },
    /**
     * 获取提交进度%
     */
    getSubmitProgress(data) {
      var list = data == '' ? [] : data.split(',')
      var result = 0
      for (var i = 0; i < list.length; i++) {
        list[i] = list[i] && list[i] != '' ? list[i] : 0
        result += parseFloat(list[i])
      }
      if (result == 0) {
        return 0
      } else {
        return (result / list.length).toFixed(2)
      }
    },
    /**
     * 新增计划
     */
    sumbitAddRow() {
      var that = this
      if (parseInt(this.addForm.plannedDate) <= 0) {
        this.$message.error('请输入天数且输入天数大于等于1天')
        return
      }
      this.addForm.plannedEndTime = util.myTime.getDaysByDate(
        this.addForm.plannedStartTime,
        this.addForm.plannedDate
      )
      if (this.addForm.id == '') {
        myHttp.addProgress(this.addForm).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('添加成功')
            that.addFormVisible = false
            ;(that.addForm = {
              //添加内容
              id: '',
              planName: '', //计划名称
              planDescribe: '',
              plannedStartTime: '',
              plannedEndTime: '',
              levelId: '0', //同级别的id
              plannedDate: '', //计划天数
              projectId: that.projectId
            }),
              that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      } else {
        myHttp.addProgress(this.addForm).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('添加成功')
            that.addFormVisible = false
            ;(that.addForm = {
              //添加内容
              id: '',
              planName: '', //计划名称
              planDescribe: '',
              plannedStartTime: '',
              plannedEndTime: '',
              levelId: '0', //同级别的id
              plannedDate: '', //计划天数
              projectId: that.projectId
            }),
              that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      }
    },
    /**
     * 监听同级别计划
     */
    changeLevel(e) {
      if (e && '' != e) {
        var list = this.optPlans
        var obj = ''
        for (var i = 0; i < list.length; i++) {
          if (list[i].id == e) {
            obj = list[i]
          }
        }
        this.addForm.plannedStartTime = util.myTime.getDateByDays(
          obj.plannedEndTime,
          2
        )
      } else {
        this.addForm.plannedStartTime = util.myTime.formatTime(
          this.num.wcl,
          'YYYY-MM-dd'
        )
      }
    },

    /**
     * 添加
     */
    addPlanCtl() {
      this.addFormVisible = true
      this.dialogTitle = '新增计划'
      this.addForm = {
        //添加内容
        id: '',
        planName: '', //计划名称
        planDescribe: '',
        plannedStartTime: util.myTime.formatTime(this.num.wcl, 'YYYY-MM-dd'),
        plannedEndTime: '',
        levelId: '0', //同级别的id
        plannedDate: '', //计划天数
        projectId: this.projectId
      }
      this.getOptPlans('')
    },

    /**
     * 修改集成列表
     */
    modPlanBtn(obj) {
      var that = this
      this.addFormVisible = true
      this.dialogTitle = '修改计划'
      obj.levelId = obj.levelId == '0' ? '' : obj.levelId
      this.addForm = {
        //添加内容
        id: obj.id,
        planName: obj.planName, //计划名称
        planDescribe: obj.planDescribe,
        plannedStartTime: obj.plannedStartTime,
        plannedEndTime: '',
        levelId: obj.levelId, //同级别的id
        plannedDate: obj.plannedDate, //计划天数
        projectId: this.projectId
      }
      this.getOptPlans(obj.plannedStartTime)
    },

    /**
     * 监听年份改变
     */
    changYear(e, a) {
      // this.selYear = new Date(e).getFullYear() + ''
      this.getDay(e)
      this.getData()
    }
  }
}
</script>
<style scoped>
.table_wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  height: calc(100vh - 245px);
}
.process-l {
  width: 180px;
}
.head-l {
  width: 100%;
  height: 60px;
  position: relative;
}
.process-r {
  width: calc(100% - 180px);
}
.head-r {
  height: 60px;
  text-align: left;
}
.head-cell {
  width: 47px;
  /* height: 30px; */
  font-size: 14px;
  text-align: center;
  display: inline-block;
  line-height: 30px;
  border-radius: 6px;
  cursor: pointer;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.head-cell:hover,
.head-cell:hover .head-cell-line,
.head-cell.cur .head-cell-line{
  background: #4d87f5;
  color: #fff;
  display: inline-block;
}
.head-cell.cur {
  background: #4d87f5;
  color: #fff;
  position: absolute;
  right: 2px;
  bottom: 0;
}
.head-cell-line {
  width: 2px;
  height: 200px;
  background: #4d87f5;
  display: inline-block;
  position: absolute;
  top: 29px;
  left: 24px;
  z-index: 10;
}
.box-r,.head-r{
  width: 1530px;
}
.head-r-box {
  /* height: 10px; */
  font-size: 14px;
  line-height: 30px;
  /* width: 150%; */
  width: 1530px;
}
.process-title {
  display: flex;
  align-content: center;
  align-items: center;
  padding: 10px;
  font-size: 18px;
  font-weight: 500;
}
.process-box {
  width: auto;
  overflow: auto;
  height: 100%;
}
.process-box-item {
  padding: 10px 0;
  position: relative;
}
.process-title,
.process-box-item {
  width: 100%;
  height: 120px;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
}
.item-div {
  height: 48px;
  width: 1270px;
  position: relative;
  padding: 8px 0;
  box-sizing: border-box;
}
.item-span {
  width: 1440px;
  height: 100%;
  border-radius: 6px;
  position: relative;
}
.color1 {
  background: #45ABF0;
}
.color2 {
  background: #45DEF0;
}
.span-txt {
  width: 46px;
  height: 28px;
  border-radius: 6px;
  position: absolute;
  top: 2px;
  /* background: #aecfdc; */
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #fff;
  justify-content: center;
}
.head-cell-line {
  display: none;
  z-index: 10;
}
.curDiv span {
  background: #4d87f5;
  color: #fff;
  display: block;
}
.layui-btn {
  display: inline-block;
  height: 38px;
  line-height: 38px;
  padding: 0 18px;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border: none;
  border-radius: 2px;
  cursor: pointer;
}
.paneCtl {
  position: absolute;
  background: #17b2fe;
  position: absolute;
  top: 15px;
  right: 20px;
}
.layui-layer-title {
  text-align: center;
  padding: 0 20px;
}
#qualityAdd .layui-form-label {
  text-align: left;
  padding-left: 0;
}
#qualityAdd .layui-input-block {
  margin-left: 0;
}
#qualityAdd .layui-input-inline {
  min-width: 180px;
}
.submitCtl {
  background: #17b2fe;
  position: absolute;
  top: 63px;
  right: 20px;
}
.colorSign {
  width: 42px;
  height: 30px;
  display: inline-block;
  align-items: center;
  border-radius: 6px;
}
.signName {
  margin: 0 20px 0 5px;
  line-height: 30px;
}
.modPlanBtn {
  position: absolute;
  top: 20px;
  right: 40px;
  width: 28px;
  height: 28px;
  cursor: pointer;
}
.mangerBtn{
  position: absolute;
  top: 20px;
  right: 1px;
  width: 28px;
  height: 28px;
  cursor: pointer;
}
.submit-btn{
  position: absolute;
  top: 70px;
  right: 40px;
  width: 28px;
  height: 28px;
  cursor: pointer;
}
</style>
